<template>
  <section>
    <svg
      class="trigger pointer"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      @click="openSearch"
    >
      <path
        fill="#979797"
        d="M13.7087003,11.7087003 L17.5,15.5 C18.0522847,16.0522847 18.0522847,16.9477153 17.5,17.5 C16.9477153,18.0522847 16.0522847,18.0522847 15.5,17.5 L11.7087003,13.7087003 C10.5086822,14.5237436 9.05995891,15 7.5,15 C3.35786438,15 0,11.6421356 0,7.5 C0,3.35786438 3.35786438,0 7.5,0 C11.6421356,0 15,3.35786438 15,7.5 C15,9.05995891 14.5237436,10.5086822 13.7087003,11.7087003 Z M7.5,13 C10.5375661,13 13,10.5375661 13,7.5 C13,4.46243388 10.5375661,2 7.5,2 C4.46243388,2 2,4.46243388 2,7.5 C2,10.5375661 4.46243388,13 7.5,13 Z"
      />
    </svg>
    <transition name="overlay-fade">
      <div v-if="opened" class="backdrop" @click="opened = false"></div>
    </transition>
    <transition name="slidein">
      <section
        v-if="opened"
        class="search-panel"
        :class="{ 'search-panel-mobile': rootStore.isMobile }"
      >
        <form @submit.prevent="search" @click.stop>
          <input
            type="text"
            v-model="searchString"
            placeholder="Zoeken naar"
            @click.stop=""
            ref="search"
          />
          <button class="pill-button">Zoek</button>
        </form>
      </section>
    </transition>
  </section>
</template>

<script>
import { mapStores } from 'pinia'
import { usePrintStoreStore } from '@/features/printstore/PrintStore.store'
import { ro } from 'date-fns/locale'

export default {
  name: 'SearchMenu',
  data() {
    return {
      opened: false,
      searchString: ''
    }
  },
  computed: {
    ...mapStores(usePrintStoreStore)
  },
  methods: {
    openSearch() {
      this.opened = true
      this.searchString = ''
      // Set focus after animation has finished
      setTimeout(() => {
        this.$refs.search.focus()
      }, 300)
    },
    async search() {
      const searchDefault = this.rootStore.theme.customFields.printStore
        .hideDefaultContent
        ? 0
        : 1

      this.searchString = this.searchString.trim()
      if (!this.searchString) {
        return
      }
      this.printStoreStore.searchString = this.searchString
      await this.printStoreStore.search({ d: searchDefault })
      this.opened = false
      await this.$router.push({ name: 'printStoreSearchResults' })
    }
  }
}
</script>

<style scoped lang="scss">
.trigger {
  width: 20px;
  height: 20px;

  path {
    fill: var(--sub-color);
  }
}

.search-panel {
  position: absolute;
  width: 240px;
  background: white;
  padding: 15px;
  border-radius: 30px;
  right: 15px;
  z-index: 15;
  top: -2px;
  box-shadow: rgba(0, 0, 0, 0.3) 0 0 20px -5px;

  &.search-panel-mobile {
    top: 15px;
  }

  svg {
    vertical-align: middle;
    margin-right: 10px;
  }
}

input {
  border: none;
  margin: 0;
  //  padding: 15px;
}

.slidein-enter-active {
  animation: show-up 0.35s;
  animation-timing-function: ease-out;
  transform-origin: 100% 0;
}
.slidein-leave-active {
  animation: show-up 0.35s reverse ease-out;
  transform-origin: 100% 0;
}
@keyframes show-up {
  0% {
    opacity: 0;
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: scale(1.1);
  }

  100% {
    transform: scale(1);
  }
}
</style>
